/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 22/11/21
 */
import React, {memo, useState, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Collapse} from 'antd';
import SectionTitle from '@/modules/templates/components/TemplateSectionsDrawer/components/SectionTitle';
import WrapperFieldType from '@/modules/templates/components/TemplateSectionsDrawer/components/WrapperFieldType';
import {useTranslation} from 'react-i18next';
import styles from './index.less';
import MobileSectionTitle from '@/modules/auditorAudits/components/WrapperRunAudit/components/ManageAuditContent/components/ResponseList/components/MobileSectionTitle';
import {useAuditData} from '@/modules/auditorAudits/hooks/useAuditData';
import {CONTACT_POOLS_FIELDS} from '@/modules/auditorAudits/contants/auditorAudits';

const { Panel } = Collapse;

const SectionBox = ({section, id, runAudit = false, isCover, isContact}) => {
  const {t} = useTranslation('templates');
  const { currentAudit } = useAuditData();

  const [activeKey, setActiveKey] = useState(['1']);

  const filteredContactFields = useMemo(() => {
    if (!currentAudit?.service?.isPoolService) {
      return section?.metadata?.contactFields?.filter((field) => {
        return !CONTACT_POOLS_FIELDS.includes(field?.type);
      });
    }
    else {
      return section?.metadata?.contactFields;
    }
  }, [currentAudit?.service?.isPoolService, section?.metadata?.contactFields]);

  if (runAudit) {
    return (
      <div id={id} className="wrapper-section-panel">
        {isCover
          ? <Collapse defaultActiveKey={activeKey} bordered={false} onChange={setActiveKey} className={styles.wrapperPanel}>
            <Panel className="wrapper-panel-audit" header={<SectionTitle section={section} runAudit={runAudit} activeKey={activeKey} isCover={isCover} />} key="1" showArrow={false}>
              {section?.metadata?.coverFields?.length === 0
                ?
                <div className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
                : section?.metadata?.coverFields?.map(item => {
                  return <WrapperFieldType key={item?._id} type={item?.type} question={item} isCover runAudit={runAudit} sectionId={section?._id} />;
                })}
            </Panel>
          </Collapse>

          : isContact ?
            <Collapse defaultActiveKey={activeKey} bordered={false} onChange={setActiveKey} className={styles.wrapperPanel}>
              <Panel className="wrapper-panel-audit" header={<SectionTitle section={section} runAudit={runAudit} activeKey={activeKey} isCover={isContact} />} key="1" showArrow={false}>
                {section?.metadata?.contactFields?.length === 0
                  ?
                  <div className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
                  : filteredContactFields?.map(item => {
                    return <WrapperFieldType key={item?._id} type={item?.type} question={item} runAudit={runAudit} sectionId={section?._id} isContact />;
                  })}
              </Panel>
            </Collapse>
            :
            <Collapse defaultActiveKey={activeKey} bordered={false} onChange={setActiveKey} className={styles.wrapperPanel}>
              <Panel className="wrapper-panel-audit" header={<SectionTitle section={section} runAudit={runAudit} activeKey={activeKey} />} key="1" showArrow={false}>
                {section?.questions?.length === 0 && !section?.metadata
                  ? <div className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
                  : section?.questions?.map(item => {
                    return  (
                      <WrapperFieldType key={item?._id} type={item?.type} question={item} sectionId={section?._id} runAudit={runAudit} />
                    );
                  })}
              </Panel>
            </Collapse>}
      </div>
    );
  }

  return (
    <div id={id}>
      <MobileSectionTitle section={section} />
      {section?.metadata?.coverFields?.length === 0
        ? <div className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
        : section?.metadata?.coverFields?.map(item => {
          return <WrapperFieldType key={item?._id} type={item?.type} question={item} isCover sectionId={section?._id} />;
        })}
      {section?.questions?.length === 0 && !section?.metadata
        ? <div className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
        : section?.questions?.map(item => {
          return <WrapperFieldType key={item?._id} type={item?.type} question={item} sectionId={section?._id} />;
        })}
      {section?.metadata?.contactFields?.length === 0
        ? <div className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
        : filteredContactFields?.map(item => {
          return <WrapperFieldType key={item?._id} type={item?.type} question={item} isCover sectionId={section?._id} />;
        })}
    </div>
  );
};

SectionBox.propTypes = {
  section: PropTypes.object,
  id: PropTypes.string,
  runAudit: PropTypes.bool,
  isCover: PropTypes.bool,
  isContact: PropTypes.bool,
};

export default memo(SectionBox);
